export default __webpack_public_path__ + "static/102-ba25c5d791fec95795c760b772a08d20.jpg";